import APIService from "./API.service";
const queryString = require("query-string");

class BadgeTemplate extends APIService {
  // Get list of badge template by event id
  getBadgeTemplates(eventId: number) {
    const query = {
      token: localStorage.getItem("fielddrive-token"),
    };

    return this.call.get(
      `${this.apiUrl}/badge_template/${eventId}?${queryString.stringify(query)}`
    );
  }

  // Delete a badge template by id
  deleteTemplate(templateId: number) {
    const query = {
      token: localStorage.getItem("fielddrive-token"),
    };
    return this.call.delete(
      `${this.apiUrl}/badge_template/${templateId}?${queryString.stringify(
        query
      )}`
    );
  }

  // Create a badge template
  createTemplate(data: {
    badgeFormat: number;
    event_id: string;
    name: string;
    xmlBackSideTemplate: string;
    xmlFrontSideTemplate: string;
  }) {
    const query = {
      token: localStorage.getItem("fielddrive-token"),
    };
    return this.call.post(
      `${this.apiUrl}/badge_template/${data.event_id}?${queryString.stringify(
        query
      )}`,
      JSON.stringify(data)
    );
  }
}

export default BadgeTemplate;
